import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EmailProblemsApi } from '../../../apis/EmailProblemsApi/EmailProblemsApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export const useSendVerificationMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => EmailProblemsApi.sendVerification(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.emailProblems] });
        },
    });
}; 